import { cn } from '@exam-room/utils';

interface TableDataCellProps extends React.TdHTMLAttributes<HTMLTableDataCellElement> {
  className?: string;
}

export default function TableDataCell({ children, className, ...props }: TableDataCellProps) {
  return (
    <td className={cn('p-3', className)} {...props}>
      {children}
    </td>
  );
}
